<template lang='pug' src='./custom-home-tagline.pug'></template>

<script>
export default {
  props: ['props']
}
</script>



// WEBPACK FOOTER //
// custom-home-tagline.vue?40b4de10